<template>
    <div>
        <div class="findTitle">
            <span>{{title}}</span>
        </div>
        <div class="statistic">
            <div class="statistic_title">
                <span v-for="(item, index) of itemTitleList" :key="index" :style="item.style">{{item.name}}
                </span>
            </div>
            <div class="bottom_content">
                <div class="statistic_content" v-for="(data, indexRow) of dealersTabelData" :key="indexRow">
                    <span v-for="(item, indexCum) of itemTitleList" :key="indexCum" :style="item.style">
                        <span class="showLabel" :style="showColor(indexRow)" v-if="indexCum === 0&indexShow">{{indexRow + 1}}</span>
                        <el-tooltip class="item" effect="dark" :content="data[item.key] ? data[item.key].toString() : ''" placement="top">
                            <span>{{data[item.key]}}</span>
                        </el-tooltip>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            style: [{'background-color': '#DC143C'},
                {'background-color': '#FFD700'},
                {'background-color': '#1E90FF'},
                {'background-color': '#cccccc'}]
        };
    },
    methods: {
        showColor(row) {
            if (row < 3) {
                return this.style[row];
            }
            return this.style[3];
        }
    },
    props: ['dealersTabelData', 'title', 'itemTitleList', 'indexShow']
};
</script>

<style scoped>
    .findTitle{
        margin-bottom: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 25px;
    }
    .statistic{
        display: flex;
        flex-direction: column;
        height: calc(100% - 35px);
    }
    .bottom_content{
        flex: 1;
        overflow-y: auto;
    }
    .findTitle>span{
        font-size: 12px;
        margin: 10px 0 10px 0;
        color: white;
    }
    .statistic,.findTitle{
        background-color: rgb(11,25,70);
    }
    .statistic_title,.statistic_content{
        display: flex;
    }
    .statistic_content>span,.statistic_title>span{
        text-align: center;
        margin: 8px 0 8px 10px;
        font-size: 12px;
        color: #67A2C5;
        overflow: hidden;
        display: block;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .statistic_content>span:nth-child(1),.statistic_title>span:nth-child(1){
        text-align: left;
    }
    .showLabel{
        padding: 2px;
        font-size: 12px;
        text-align: center;
        margin-right: 5px;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/views/cloud/analysis/channelingList.vue